/**
 * Use this format to show long localized date when using DateFns library's format function
 * For more info, see https://date-fns.org/docs/format
 * @example
 * If todays date is 12 March 2025, then using this format:
 *  - In enUS localization, it will give Mar 12, 2025
 *  - In pl (Polish) localization, it will give 12 mar 2025
 */
export const longLocalizedDateFormatDateFns = "PP";

/**
 * Use this format for API date values that do not include a time or timezone.
 */
export const apiDateFormatDateFns = "yyyy-MM-dd";
